import api from "app/api/requests/Gallery";
import getChatToken from "app/api/getChatToken";
import { Album } from 'app/api/types';

export const ADD_ALBUM = 'ADD_ALBUM';

export const putAlbums = (album: Album) => (dispatch: any): any => {
	const token = getChatToken();
	return api.putAlbum(token, album)
		.then(response => {
			dispatch({
				type: ADD_ALBUM, payload: response
			});
		});
}
